import gsap from 'gsap';

export default function initHero() {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    const logoImg = hero.querySelector('.hero__logo img');

    if (!logoImg) return;

    gsap.set(logoImg, { opacity: 0 });

    const tl = gsap.timeline({
        defaults: {
            duration: 1.6,
            ease: 'power3.out'
        }
    });

    tl.to(logoImg, {
        opacity: 1
    });

    const video = hero.querySelector('video');
    const pauseBtn = hero.querySelector('.hero__pause');

    if (video && pauseBtn) {
        pauseBtn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                pauseBtn.classList.remove('is-paused');
                pauseBtn.setAttribute('aria-label', 'Pause video');
                pauseBtn.setAttribute('title', 'Pause video');
            } else {
                video.pause();
                pauseBtn.classList.add('is-paused');
                pauseBtn.setAttribute('aria-label', 'Play video');
                pauseBtn.setAttribute('title', 'Play video');
            }
        });
    }
}
